import React, { useEffect, useState } from 'react';
import { Row, Col, Badge } from 'react-bootstrap';
import { formatarMonetario } from '~/Utils/Helpers';
import * as helpers from '../../Utils/Helpers';
import Loading from '../Loading';
import { gerarAmbienteUrl } from '~/Pages/Vendas/helpers';
import * as api from '~/Services/Service';
import { toast } from 'react-toastify';
import { FaHome } from 'react-icons/fa';

const calcularPorcentagem = (valorOriginal, valorEfetivado) => {
  const diferenca = (valorEfetivado - valorOriginal) / valorOriginal;
  return new Intl.NumberFormat('pt-BR', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(diferenca);
};

const temDiferencaSignificativa = (valor1, valor2, tolerancia = 0.01) => {
  const diferenca = Math.abs(valor1 - valor2);
  const epsilon = 0.000001;
  return valor1 !== valor2 && diferenca > tolerancia + epsilon;
};

const obterDescricaoFase = fase => {
  switch (fase) {
    case 2:
      return ' Corretor - Cadastro Rápido';
    case 3:
      return ' Financeiro - Valor Não Entregue';
    case 4:
      return ' Secretaria de Vendas - Lançamento';
    case 5:
      return ' Corretor - Venda pendente para regularização';
    case 6:
      return ' Secretaria de Vendas - Emissão Contrato';
    case 7:
      return ' Cliente - Aguardando Assinatura';
    case 8:
      return ' Diretoria - Aguardando Assinatura';
    case 9:
      return ' Financeiro - Aguardando Quitar Sinal';
    case 10:
      return ' Cliente - Contrato Enviado';
    default:
      return '';
  }
};

const obterDetalheTipoComissao = tipo => {
  switch (tipo) {
    case 1:
      return 'Tipo 1 - Retida Corretor';
    case 7:
      return 'Tipo 7 - Comissão Contrato 2';
  }
};

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.innerWidth < 768
  );

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return isMobile;
};

const Section = ({ color, title, children, compact }) => (
  <div
    style={{
      background: '#fff',
      borderLeft: `4px solid ${color}`,
      borderRadius: 4,
      boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
      padding: compact ? '8px 12px' : '14px 18px',
      marginBottom: compact ? 8 : 14,
    }}
  >
    <h6
      style={{
        fontWeight: 600,
        color,
        marginBottom: compact ? 4 : 10,
        paddingBottom: compact ? 3 : 6,
        borderBottom: '1px solid #e9ecef',
        fontSize: compact ? '0.8rem' : '0.9rem',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
      }}
    >
      {title}
    </h6>
    {children}
  </div>
);

const Field = ({ label, value, children, className, style, compact }) => (
  <div style={{ marginBottom: compact ? 2 : 8 }}>
    <small
      style={{
        display: 'block',
        fontSize: compact ? '0.62rem' : '0.7rem',
        color: '#6c757d',
        textTransform: 'uppercase',
        letterSpacing: '0.3px',
        marginBottom: 0,
        lineHeight: 1.2,
      }}
    >
      {label}
    </small>
    <span
      style={{
        display: 'block',
        fontSize: compact ? '0.85rem' : '0.93rem',
        fontWeight: 600,
        color: '#212529',
        lineHeight: compact ? 1.3 : 1.5,
        ...style,
      }}
      className={className}
    >
      {children || value}
    </span>
  </div>
);

const ComparisonBlock = ({ title, valorOriginal, valorEfetivado, compact }) => (
  <div style={{ flex: 1 }}>
    <small
      className="d-block font-weight-bold text-uppercase"
      style={{
        color: '#495057',
        letterSpacing: '0.3px',
        fontSize: compact ? '0.68rem' : '0.75rem',
        marginBottom: compact ? 2 : 4,
      }}
    >
      {title}
    </small>
    <div
      className="d-flex align-items-center bg-light rounded"
      style={{
        gap: compact ? 6 : 12,
        padding: compact ? '4px 8px' : '8px 12px',
        flexWrap: 'wrap',
      }}
    >
      <Field label="Original" compact={compact} style={{ marginBottom: 0 }}>
        {formatarMonetario(valorOriginal)}
      </Field>
      {temDiferencaSignificativa(valorOriginal, valorEfetivado) && (
        <>
          <span
            className="text-muted"
            style={{ fontSize: compact ? '0.9rem' : '1.1rem' }}
          >
            →
          </span>
          <Field
            label="Efetivado"
            compact={compact}
            className={
              valorEfetivado > valorOriginal ? 'text-success' : 'text-warning'
            }
            style={{ marginBottom: 0 }}
          >
            {formatarMonetario(valorEfetivado)}
          </Field>
          <span
            className="font-weight-bold"
            style={{
              display: 'inline-block',
              padding: compact ? '1px 6px' : '2px 8px',
              borderRadius: 12,
              fontSize: compact ? '0.7rem' : '0.8rem',
              background:
                valorEfetivado > valorOriginal ? '#d4edda' : '#fff3cd',
              color: valorEfetivado > valorOriginal ? '#155724' : '#856404',
            }}
          >
            {calcularPorcentagem(valorOriginal, valorEfetivado)}
          </span>
        </>
      )}
    </div>
  </div>
);

const CondicionanteItem = ({ item, index, compact }) => {
  const perBalao = Number(item.per_balao);
  const tipo =
    perBalao === 1
      ? 'Construção'
      : perBalao === 2
      ? 'Adimplência'
      : perBalao === 3
      ? 'SetClube'
      : '';
  const percentual =
    perBalao === 1
      ? item.percentual_construcao
      : perBalao === 3
      ? 0
      : item.percentual_adimplencia;
  const meses =
    perBalao === 1
      ? item.meses_construcao
      : perBalao === 3
      ? 0
      : item.meses_adimplencia;

  return (
    <div
      className="d-flex align-items-center rounded mb-1"
      style={{
        padding: compact ? '4px 8px' : '8px 12px',
        background: index % 2 === 0 ? '#f8f9fa' : '#fff',
        border: '1px solid #e9ecef',
        flexWrap: 'wrap',
      }}
    >
      <Col
        md={3}
        xs={compact ? 12 : undefined}
        className="d-flex align-items-center"
      >
        <span
          className="font-weight-bold text-center"
          style={{
            display: 'inline-block',
            padding: '2px 10px',
            borderRadius: 12,
            fontSize: compact ? '0.72rem' : '0.8rem',
            background: '#e9ecef',
            color: '#495057',
            minWidth: compact ? 80 : 100,
          }}
        >
          {tipo}
        </span>
      </Col>
      <Col md={3} xs={4}>
        <Field
          label="Valor Futuro"
          compact={compact}
          style={{ marginBottom: 0 }}
        >
          {formatarMonetario(item.valor)}
        </Field>
      </Col>
      <Col md={3} xs={4}>
        <Field
          label="Valor Presente"
          compact={compact}
          style={{ marginBottom: 0 }}
        >
          {formatarMonetario(item.valor_presente)} {' - '} {percentual}%
        </Field>
      </Col>
      <Col md={3} xs={4}>
        <Field label="Condição" compact={compact} style={{ marginBottom: 0 }}>
          {meses} meses
        </Field>
      </Col>
    </div>
  );
};

const DetalhesAtivo = ({ linhaSelecionada, ativo }) => {
  const [detalhesPrevenda, setDetalhesPrevenda] = useState(null);
  const [sociedade, setSociedade] = useState(null);
  const compact = useIsMobile();

  useEffect(() => {
    if (linhaSelecionada && linhaSelecionada.pre_venda) {
      api
        .obterDetalhesPrevenda(linhaSelecionada.pre_venda)
        .then(res => {
          setDetalhesPrevenda(res);
        })
        .catch(err => {
          toast.error('Erro ao obter detalhes da pré-venda:', err);
        });
    }

    if (linhaSelecionada && linhaSelecionada.codigo_proposta) {
      api
        .obterSociedadeManutencaoVenda(
          linhaSelecionada.codigo_proposta,
          linhaSelecionada.seq
        )
        .then(res => {
          setSociedade(res);
        })
        .catch(() => {
          setSociedade(null);
        });
    }
  }, [linhaSelecionada]);

  return (
    <>
      {ativo && (
        <div className="mt-1">
          <Section
            color="#007bff"
            title="Informações do Terreno"
            compact={compact}
          >
            <Row>
              <Col md={4} xs={6}>
                <Field
                  label="Empreendimento"
                  value={linhaSelecionada.empreendimento}
                  compact={compact}
                />
              </Col>
              <Col md={3} xs={6}>
                <Field label="Quadra / Lote" compact={compact}>
                  {linhaSelecionada.qd} / {linhaSelecionada.lt}
                </Field>
              </Col>
              <Col md={3} xs={6}>
                <Field label="Ativo" compact={compact}>
                  {ativo.codigo}
                  {ativo.casa != 0 && (
                    <Badge
                      variant="info"
                      className="ml-1"
                      style={{ fontSize: compact ? '0.65rem' : undefined }}
                    >
                      <FaHome /> Com construção
                    </Badge>
                  )}
                </Field>
              </Col>
              <Col md={2} xs={6}>
                <Field label="Área" compact={compact}>
                  {ativo.area}m²
                </Field>
              </Col>
            </Row>
            <Row>
              {detalhesPrevenda && detalhesPrevenda.data_ultimo_negocio && (
                <Col md={4} xs={6}>
                  <Field label="Estoque desde" compact={compact}>
                    {helpers.format.date(detalhesPrevenda.data_ultimo_negocio)}{' '}
                    ({detalhesPrevenda.dias_estoque} dias)
                  </Field>
                </Col>
              )}
              {ativo.matricula && (
                <Col md={4} xs={6}>
                  <Field
                    label="Matrícula"
                    value={ativo.matricula}
                    compact={compact}
                  />
                </Col>
              )}
              {ativo.link_prefeitura && (
                <Col md={4} xs={6}>
                  <Field label="Prefeitura" compact={compact}>
                    <a
                      href={ativo.link_prefeitura}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Acessar site da prefeitura
                    </a>
                  </Field>
                </Col>
              )}
            </Row>
          </Section>

          <Section
            color="#28a745"
            title="Informações da Venda"
            compact={compact}
          >
            <Row>
              <Col md={4} xs={5}>
                <Field label="Data da Venda" compact={compact}>
                  {helpers.format.datetime(ativo.data_venda)}
                </Field>
              </Col>
              <Col md={8} xs={7}>
                <Field label="Fase" compact={compact}>
                  <Badge
                    variant="primary"
                    className="mr-1"
                    style={{ fontSize: compact ? '0.65rem' : undefined }}
                  >
                    {linhaSelecionada.fase}
                  </Badge>
                  {obterDescricaoFase(linhaSelecionada.fase)}
                </Field>
              </Col>
            </Row>
            <div
              className="d-flex"
              style={{ gap: compact ? 8 : 16, marginBottom: compact ? 4 : 8 }}
            >
              <ComparisonBlock
                title="Valor da Venda"
                valorOriginal={ativo.vv_original}
                valorEfetivado={ativo.vv_efetivado}
                compact={compact}
              />
              <ComparisonBlock
                title="Sinal"
                valorOriginal={ativo.sinal_original}
                valorEfetivado={ativo.sinal_efetivado}
                compact={compact}
              />
            </div>
          </Section>

          <Section color="#17a2b8" title="Comissão e Valores" compact={compact}>
            <Row>
              <Col md={4} xs={6}>
                <Field label="Tipo Comissão" compact={compact}>
                  {obterDetalheTipoComissao(ativo.tipo_comissao)}
                </Field>
              </Col>
              {ativo.sinal_imobiliaria && (
                <Col md={4} xs={6}>
                  <Field label="Sinal Imobiliária" compact={compact}>
                    {formatarMonetario(ativo.sinal_imobiliaria)}
                  </Field>
                </Col>
              )}
              {ativo.sinal_incorporadora && (
                <Col md={4} xs={6}>
                  <Field label="Sinal Incorporadora" compact={compact}>
                    {formatarMonetario(ativo.sinal_incorporadora)}
                  </Field>
                </Col>
              )}
            </Row>
            <Row>
              <Col md={4} xs={6}>
                <Field label="Valor Bruto do m²" compact={compact}>
                  {formatarMonetario(ativo.vv_original / ativo.area)}
                </Field>
              </Col>
              <Col md={4} xs={6}>
                <Field label="Valor Líquido do m²" compact={compact}>
                  {formatarMonetario(ativo.vv_efetivado / ativo.area)}
                </Field>
              </Col>
            </Row>
            {sociedade && sociedade.codigo_corretor && (
              <Row>
                <Col md={4} xs={4}>
                  <Field label="Divisão de Comissão" compact={compact}>
                    <Badge
                      variant="warning"
                      style={{ fontSize: compact ? '0.65rem' : undefined }}
                    >
                      Com divisão
                    </Badge>
                  </Field>
                </Col>
                <Col md={4} xs={4}>
                  <Field
                    label="Corretor Sócio"
                    value={sociedade.nome}
                    compact={compact}
                  />
                </Col>
                <Col md={4} xs={4}>
                  <Field label="Percentual" compact={compact}>
                    {sociedade.porcentagem}%
                  </Field>
                </Col>
              </Row>
            )}
          </Section>

          <Section color="#6f42c1" title="Tabela e Pagamento" compact={compact}>
            <Row>
              <Col md={4} xs={6}>
                <Field
                  label="Usuário Proposta"
                  value={ativo.usuario_proposta}
                  compact={compact}
                />
              </Col>
              {ativo.usuario_proposta !== ativo.usuario_pre_venda && (
                <Col md={4} xs={6}>
                  <Field
                    label="Usuário Pré-Venda"
                    value={ativo.usuario_pre_venda}
                    compact={compact}
                  />
                </Col>
              )}
              <Col md={4} xs={12}>
                <Field label="Tabela" compact={compact}>
                  {ativo.codigo_tabela} - {ativo.descricao_tabela}
                </Field>
              </Col>
            </Row>
            <Row>
              {detalhesPrevenda && (
                <>
                  <Col md={4} xs={6}>
                    <Field
                      label="Correção"
                      value={detalhesPrevenda.periodicidade_correcao}
                      compact={compact}
                    />
                  </Col>
                  <Col md={4} xs={6}>
                    <Field label="Plano" compact={compact}>
                      {detalhesPrevenda.plano}x
                    </Field>
                  </Col>
                </>
              )}
              {detalhesPrevenda &&
                detalhesPrevenda.prazo_financiamento_meses > 0 && (
                  <Col md={3} xs={6}>
                    <Field label="Prazo Financiamento" compact={compact}>
                      {detalhesPrevenda.prazo_financiamento_meses} meses
                    </Field>
                  </Col>
                )}
              {detalhesPrevenda && (
                <Col md={3} xs={6}>
                  <Field label="Início Juros" compact={compact}>
                    {helpers.format.date(
                      detalhesPrevenda.prazo_financiamento_meses > 0
                        ? helpers
                            .createDate(ativo.data_venda)
                            .add(
                              detalhesPrevenda.prazo_financiamento_meses,
                              'months'
                            )
                        : helpers.createDate(ativo.data_venda).add(30, 'days')
                    )}
                  </Field>
                </Col>
              )}
            </Row>
            <Row>
              {ativo.codigo_prospecto_construtor > 0 && (
                <Col md={4} xs={6}>
                  <Field
                    label="Prospecto Construtor"
                    value={ativo.codigo_prospecto_construtor}
                    compact={compact}
                  />
                </Col>
              )}
              {ativo.cheque_bonus_aplicado > 0 && (
                <Col md={4} xs={6}>
                  <Field label="Cheque Bônus Aplicado" compact={compact}>
                    {formatarMonetario(ativo.cheque_bonus_aplicado)}
                  </Field>
                </Col>
              )}
              {detalhesPrevenda &&
                detalhesPrevenda.codigo_venda_condicao_especial > 0 && (
                  <Col md={4} xs={6}>
                    <Field
                      label="Condição Especial"
                      className="text-danger"
                      compact={compact}
                    >
                      #{detalhesPrevenda.codigo_venda_condicao_especial}
                    </Field>
                  </Col>
                )}
            </Row>
          </Section>

          {ativo.codigo_desconto > 0 && (
            <Section color="#ffc107" title="Desconto" compact={compact}>
              <Row>
                <Col md={6} xs={6}>
                  <Field label="Solicitação de Desconto V1" compact={compact}>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href={`${gerarAmbienteUrl(
                        true
                      )}/Descontos/Inserir.aspx?ID=${ativo.codigo_desconto}`}
                    >
                      {ativo.codigo_desconto}
                    </a>
                  </Field>
                </Col>
                <Col md={6} xs={6}>
                  <Field
                    label="Aprovado por"
                    value={ativo.nome_aprovador_desconto}
                    compact={compact}
                  />
                </Col>
              </Row>
            </Section>
          )}

          {detalhesPrevenda &&
            detalhesPrevenda.condicionantes &&
            detalhesPrevenda.condicionantes.length > 0 && (
              <Section color="#dc3545" title="Condicionantes" compact={compact}>
                {detalhesPrevenda.condicionantes.map((item, index) => (
                  <CondicionanteItem
                    key={index}
                    item={item}
                    index={index}
                    compact={compact}
                  />
                ))}
              </Section>
            )}
        </div>
      )}
      {!ativo && (
        <div>
          <Loading />
        </div>
      )}
    </>
  );
};

export default DetalhesAtivo;
